<!-- 运输任务 新建、编辑 -->
 <template>
    <div>
        <el-dialog v-dialogDrag
            :title="dialogCode === 'add' ? '新增运输任务' : '编辑运输任务'" width="82%"
            :visible.sync="dialogShow" :close-on-click-modal="false"
            :before-close="handleClose">
                <div>
                    <div class="tipText"><i class="el-icon-warning-outline"></i>请先保存主任务后再编辑子任务</div>
                    <el-tabs v-model="tabsValue">
                        <el-tab-pane label="主任务详细信息" name="maindetail" >
                            <el-form ref="mianform" :model="form" label-width="120px" :inline="true" class="demo-form-inline" size="mini" 
                            :rules="mainRules">
                                <el-form-item label="委托单位" prop="customer" >
                                    <el-select  filterable clearable v-model="form.customer" style="width: 100%"
                                        placeholder="请选择委托单位"  >
                                        <el-option v-for="item in customerList" :key="item.id" :label="item.value"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="货物名称" prop="goodsName" >
                                    <el-select  filterable clearable v-model="form.goodsName" style="width: 100%"
                                        placeholder="请选择货物名称"  >
                                        <el-option v-for="item in goodsList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="提单号" prop="blNo">
                                    <el-input v-model="form.blNo"  ></el-input>
                                </el-form-item>
                                <el-form-item label="任务状态" prop="status">
                                    <el-select v-model="form.status" disabled placeholder=" " style="width: 100%;">
                                        <el-option v-for="item in taskStatus" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="发布人" prop="createMan" >
                                    <el-input v-model="form.createMan" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="发布时间" prop="createTime" >
                                    <el-input v-model="form.createTime" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="任务类型" prop="taskType">
                                    <el-select v-model="form.taskType" placeholder="请选择任务类型" style="width: 100%;"
                                     >
                                        <el-option v-for="item in taskType" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="要求到厂时间" prop="requestTime">
                                    <el-date-picker style="width: 100%;" v-model="form.requestTime" type="date" value-format="yyyy-MM-dd" 
                                    placeholder="请选择日期"  > </el-date-picker>
                                </el-form-item>
                                <el-form-item label="承运人" prop="driverMan">
                                    <!-- <el-input v-model="form.driverMan" disabled ></el-input> -->
                                    <el-select :disabled="( form.status === '新建' || form.status === '发布' || form.status === '退回' || !form.status ) ? false : true"  v-model="form.driverMan"  filterable clearable @clear="clearDriverMan" placeholder="请选择承运人" style="width: 100%;"
                                     @change="selectTruckNo">
                                        <el-option v-for="item in driverManList" :key="item.id" :label="item.driverName" :value="item.driverName"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="车牌号" prop="truckNo">
                                    <el-input v-model="form.truckNo" disabled ></el-input>
                                </el-form-item>
                                <el-form-item label="起始地址" prop="startPort">
                                    <el-select filterable clearable v-model="form.startPort" style="width: 100%" placeholder="请选择起始地址" 
                                         >
                                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="目的地址" prop="endPort">
                                    <el-select filterable clearable v-model="form.endPort" style="width: 100%"  placeholder="请选择目的地址" 
                                     >
                                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="目的详细地址" prop="endAddress">
                                    <!-- 可选可填 -->
                                    <el-select :remote-method="getAddressBy" remote filterable clearable v-model="form.endAddress" style="width: 100%"
                                        placeholder="请选择目的详细地址" @blur="selectBlur" @clear="selectClear" @change="endAddressChange"
                                         >
                                        <el-option v-for="item in portDetailList" :key="item.id" :label="item.address"
                                            :value="item.address + '-'  + item.contactMan + '-' + item.phone">
                                            <span style="float: left">{{ item.address }}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.contactMan }} -- {{ item.phone }} </span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="联系人" prop="contactMan">
                                    <el-input v-model="form.contactMan" clearable  ></el-input>
                                </el-form-item>
                                <el-form-item label="联系人电话" prop="phone">
                                    <el-input v-model="form.phone" oninput="if(value.length>11)value=value.slice(0,11)"
                                        onkeyup="this.value = this.value.replace(/[^\d]/g,'');"  clearable
                                         ></el-input>
                                </el-form-item>
                                <el-form-item label="提箱场站" prop="station"> 
                                    <el-select v-model="form.station" filterable clearable placeholder="请选择提箱场站" style="width: 100%;"
                                     >
                                        <el-option v-for="item in stationList" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="箱型" prop="containerType"> 
                                    <el-select v-model="form.containerType" filterable clearable placeholder="请选择箱型" style="width: 100%;"
                                     >
                                        <el-option v-for="item in containerTypeList" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="备注" prop="note">
                                    <el-input v-model="form.note"  ></el-input>
                                </el-form-item>
                                <el-form-item label="任务完成时间">
                                    <el-input v-model="form.arrivalTime" disabled></el-input>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button size="small" type="primary" plain @click="saveMian('mianform')">保存</el-button>
                                    <el-button size="small" type="success" plain @click="shippingFee('main')" >生成运费</el-button>
                                </el-form-item>
                            </el-form>
                            <!-- 退回原因 -->
                             <!-- <div v-if="form.status === '退回'">
                                <div style="color:red">退回原因: {{ form.rejectNote }}</div>
                             </div> -->
                            <el-divider content-position="left">附件信息</el-divider>
                            <!-- 提货附件 -->
                             <div class="label_box">
                                <div class="label_box_item" >
                                    <div class="label">
                                        提货附件
                                    </div>
                                    <div>
                                        <el-upload class="upload-demo" :action="fileUploadURL" :file-list="mainFileList" :auto-upload="false"
                                        :on-change="handleChangeMain" :on-remove="handleRemoveMain" multiple >
                                        <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
                                        <el-button size="small" type="success" plain @click="uploadFiles('main')">点击上传</el-button>
                                        </el-upload>
                                        <div>
                                            <span v-for="item in newmainFileList" :key="item.id">
                                                <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.fileName }}</el-link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="label_box_item">
                                    <div class="label">
                                        司机反馈
                                    </div>
                                    <div v-for="(item,index) in mainDriverList" :key="index" >
                                        <el-image  style="width: 50px; height: 50px;margin-left: 10px;" :src="item" :preview-src-list="mainDriverList" > </el-image>
                                    </div>
                                </div>
                             </div>
                             <el-divider  content-position="left">费用信息</el-divider>
                             <div style="margin-left: 20px; ">
                                <el-tooltip class="item" effect="dark" content="新增" placement="bottom-start">
                                    <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addCostInformation('main')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="保存全部" placement="bottom-start">
                                    <el-button type="success" size="mini" icon="el-icon-check" circle @click="saveCostInformation('main')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delCostInformation('main')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom-start">
                                    <el-button type="warning" size="mini" icon="el-icon-refresh" circle @click="RefreshCostInformation('main')"></el-button>
                                </el-tooltip>
                             </div>
                             <el-table style="margin-top:0px" :data="costInformationList" size="mini" :header-cell-style="{'text-align':'center'}"
                             @selection-change="selectCostInformationChange" >
                                <el-table-column type="selection" width="50"> </el-table-column>
                                <!-- <el-table-column  type="index" width="50"></el-table-column> -->
                                <el-table-column label="费用名称" prop="feeName" > 
                                    <template slot-scope="scope">
                                         <!-- 可选可填 -->
                                        <el-select filterable clearable v-model="scope.row.feeName" style="width: 100%"
                                            placeholder="请选择费用名称" size="mini">
                                            <el-option v-for="item in feeNamelList" :key="item.id" :label="item.value"
                                                :value="item.value"> </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="金额" prop="amount">
                                    <template slot-scope="scope">
                                        <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" v-format="'#,##0.00'" size="mini" clearable v-model="scope.row.amount" autocomplete="off"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" prop="note">
                                    <template slot-scope="scope">
                                        <el-input size="mini" clearable v-model="scope.row.note"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="创建人" prop="createMan" align="center">  </el-table-column>
                                <el-table-column label="创建时间" prop="createTime" align="center">  </el-table-column>
                             </el-table>
                        </el-tab-pane>
                        <el-tab-pane label="子任务信息" name="sondetail" :disabled="(form.id && form.id !== '')? false :  true">
                            <el-form ref="subForm" :model="subTaskForm"  label-width="120px" :inline="true" class="demo-form-inline" size="mini"
                            :rules="subTaskRules">
                                <el-form-item label="委托单位" prop="customer" >
                                        <el-select  filterable clearable v-model="subTaskForm.customer" style="width: 100%"
                                            placeholder="请选择委托单位"  >
                                            <el-option v-for="item in customerList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                </el-form-item>
                                <el-form-item label="货物名称" prop="goodsName">
                                    <el-select  filterable clearable v-model="subTaskForm.goodsName" style="width: 100%"
                                        placeholder="请选择货物名称"  >
                                        <el-option v-for="item in goodsList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="提单号" prop="blNo">
                                    <el-input v-model="subTaskForm.blNo"  ></el-input>
                                </el-form-item>
                                <el-form-item label="任务类型" prop="taskType">
                                    <el-select v-model="subTaskForm.taskType" placeholder="请选择任务类型" style="width: 100%;"
                                     >
                                        <el-option v-for="item in taskType" :key="item.label" :label="item.label" :value="item.label"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="起始地址" prop="startPort">
                                    <el-select filterable clearable v-model="subTaskForm.startPort" style="width: 100%"
                                        placeholder="请选择起始地址"  >
                                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="目的地址" prop="endPort">
                                    <el-select filterable clearable v-model="subTaskForm.endPort" style="width: 100%"
                                        placeholder="请选择目的地址"  >
                                        <el-option v-for="item in portList" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="目的详细地址" prop="endAddress">
                                    <!-- 可选可填 -->
                                    <el-select :remote-method="getAddressBy" remote filterable clearable v-model="subTaskForm.endAddress" style="width: 100%"
                                        placeholder="请选择目的详细地址" @blur="selectBlurSubTask" @clear="selectClearSubTask" @change="endAddressChangeSubTask"
                                         >
                                        <el-option v-for="item in portDetailList" :key="item.id" :label="item.address"
                                            :value="item.address + '-'  + item.contactMan + '-' + item.phone">
                                            <span style="float: left">{{ item.address }}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.contactMan }} -- {{ item.phone }} </span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="联系人" prop="contactMan">
                                    <el-input v-model="subTaskForm.contactMan" clearable  ></el-input>
                                </el-form-item>
                                <el-form-item label="联系人电话" prop="phone">
                                    <el-input v-model="subTaskForm.phone" oninput="if(value.length>11)value=value.slice(0,11)"
                                        onkeyup="this.value = this.value.replace(/[^\d]/g,'');" clearable
                                         ></el-input>
                                </el-form-item>
                                <el-form-item label="件数" prop="tons">
                                    <el-input v-model="subTaskForm.tons" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" 
                                     ></el-input>
                                </el-form-item>
                                <el-form-item label="备注" prop="note">
                                    <el-input v-model="subTaskForm.note"  ></el-input>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-button size="small" type="primary" plain @click="saveSubTask('subForm')">保存</el-button>
                                    <el-button size="small" type="success" plain @click="shippingFee('subTask')" >生成运费</el-button>
                                </el-form-item>
                            </el-form>
                            <el-divider content-position="left">附件信息</el-divider>
                            <!-- 提货附件 -->
                             <div class="label_box">
                                <div class="label_box_item" >
                                    <div class="label">
                                        提货附件
                                    </div>
                                    <div>
                                        <el-upload class="upload-demo" :action="fileUploadURL" :file-list="subTaskFileList" :auto-upload="false"
                                        :on-change="handleChangeSub" :on-remove="handleRemoveSub" multiple >
                                        <el-button slot="trigger" size="small" type="primary" plain style="margin-right: 10px;">选择文件</el-button>
                                        <el-button size="small" type="success" plain @click="uploadFiles('sub')">点击上传</el-button>
                                        </el-upload>
                                        <div>
                                            <span v-for="item in newSubFileList" :key="item.id">
                                                <el-link type="primary" class="list-margin" @click="downloadFile(item)">{{ item.fileName }}</el-link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="label_box_item">
                                    <div class="label">
                                        司机反馈
                                    </div>
                                    <div v-for="(item,index) in subDriverList" :key="index" >
                                        <el-image  style="width: 50px; height: 50px;margin-left: 10px;" :src="item" :preview-src-list="subDriverList" > </el-image>
                                    </div>
                                </div>
                             </div>
                             <el-divider  content-position="left">费用信息</el-divider>
                             <div style="margin-left: 20px; ">
                                <el-tooltip class="item" effect="dark" content="新增" placement="bottom-start">
                                    <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addCostInformation('sub')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="保存全部" placement="bottom-start">
                                    <el-button type="success" size="mini" icon="el-icon-check" circle @click="saveCostInformation('sub')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="删除" placement="bottom-start">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="delCostInformation('sub')"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="刷新" placement="bottom-start">
                                    <el-button type="warning" size="mini" icon="el-icon-refresh" circle @click="RefreshCostInformation('sub')"></el-button>
                                </el-tooltip>
                             </div>
                             <el-table style="margin-top:0px" :data="costInformationSubList" size="mini" :header-cell-style="{'text-align':'center'}"
                             @selection-change="selectCostInformationSubChange" >
                                <el-table-column type="selection" width="50"> </el-table-column>
                                <el-table-column label="费用名称" prop="feeName" > 
                                    <template slot-scope="scope">
                                        <el-select filterable clearable v-model="scope.row.feeName" style="width: 100%"
                                            placeholder="请选择费用名称" size="mini">
                                            <el-option v-for="item in feeNamelList" :key="item.id" :label="item.value"
                                                :value="item.value"> </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="金额" prop="amount">
                                    <template slot-scope="scope">
                                        <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" v-format="'#,##0.00'" size="mini" clearable v-model="scope.row.amount" autocomplete="off" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" prop="note">
                                    <template slot-scope="scope">
                                        <el-input size="mini" clearable v-model="scope.row.note"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="创建人" prop="createMan" align="center">  </el-table-column>
                                <el-table-column label="创建时间" prop="createTime" align="center">  </el-table-column>
                             </el-table>
                        </el-tab-pane>
                    </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import basicData from '@/config/basicData.js'
  export default {
    name: '',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        dialogCode: {
            type: String,
            default: ''
        },
        taskId: {
            type: String,
            default: ''
        },
        // 再来一单的主任务和子任务数据
        mianTaskData: {
            type: Object,
            default: () => {}
        },
        subTaskData: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            tabsValue:'maindetail', // tabs切换值
            form: { 
                contactMan :'',
                phone :'',
                startPort:'黄岛',
            }, // 主任务表单
            subTaskForm:{
                contactMan :'',
                phone :'',
                startPort:'黄岛',
            }, // 子任务表单
            portList:[],// 地址列表
            // 任务状态信息
            taskStatus:basicData.taskStatus,
            taskType:basicData.taskType,
            goodsList:[], // 货物列表
            customerList:[], // 委托单位列表
            driverManList:[], // 司机列表
            containerTypeList:[], // 箱型列表
            stationList:[], // 提箱场站列表
            portDetailList:[], // 详细地址信息--带出联系人和电话
            mainFileList:[], // 上传文件列表--主任务
            subTaskFileList:[], // 上传文件列表--子任务
            newmainFileList:[], // 查询已上传的文件列表--主任务
            newSubFileList:[], // 查询已上传的文件列表--子任务
            costInformationList:[], // 费用信息列表--主任务
            costInformationSubList:[], // 费用信息列表--子任务
            feeNamelList:[], // 费用方案名称列表
            selectCostInformation:[], // 选中的费用信息序号列表--主任务
            selectCostInformationSub:[], // 选中的费用信息序号列表--子任务
            fileUploadURL:process.env.VUE_APP_BASE_API + 'carTaskFile/uploadAttachments/', // 文件上传URL
            mainDriverList:[], // 主任务司机反馈图片列表，放大显示
            subDriverList:[ ], // 子任务司机反馈图片列表，放大显示
            // 添加运费方案必填
            mainRules:{
                customer:[
                    { required: true, message: '请选择委托单位', trigger: 'blur' }
                ],
                goodsName: [
                    { required: true, message: '请选择货物名称', trigger: 'blur' },
                ],
                blNo: [
                    { required: true, message: '请输入提单号', trigger: 'blur' },
                ],
                taskType: [
                    { required: true, message: '请选择任务类型', trigger: 'blur' },
                ],
                requestTime: [
                    { required: true, message: '请选择要求到厂时间', trigger: 'blur' },
                ],
                startPort: [
                    { required: true, message: '请选择起始地址', trigger: 'blur' },
                ],
                endPort: [
                    { required: true, message: '请选择目的地址', trigger: 'blur' },
                ],
                // endAddress: [
                //     { required: true, message: '请选择目的详细地址', trigger: 'blur' },
                // ],
                // contactMan: [
                //     { required: true, message: '请输入联系人', trigger: 'blur' },
                // ],
                // phone: [
                //     { required: true, message: '请输入联系人电话', trigger: 'blur' },
                // ],
                containerType: [
                    { required: true, message: '请选择箱型', trigger: 'blur' },
                ],
                station: [
                    { required: true, message: '请选择提箱场站', trigger: 'blur' },
                ]
            },
            subTaskRules:{
                customer:[
                    { required: true, message: '请选择委托单位', trigger: 'blur' }
                ],
                goodsName: [
                    { required: true, message: '请选择货物名称', trigger: 'blur' },
                ],
                blNo: [
                    { required: true, message: '请输入提单号', trigger: 'blur' },
                ],
                taskType: [
                    { required: true, message: '请选择任务类型', trigger: 'blur' },
                ],
                requestTime: [
                    { required: true, message: '请选择要求到厂时间', trigger: 'blur' },
                ],
                startPort: [
                    { required: true, message: '请选择起始地址', trigger: 'blur' },
                ],
                endPort: [
                    { required: true, message: '请选择目的地址', trigger: 'blur' },
                ],
                // endAddress: [
                //     { required: true, message: '请选择目的详细地址', trigger: 'blur' },
                // ],
                // contactMan: [
                //     { required: true, message: '请输入联系人', trigger: 'blur' },
                // ],
                // phone: [
                //     { required: true, message: '请输入联系人电话', trigger: 'blur' },
                // ],
                containerType: [
                    { required: true, message: '请选择箱型', trigger: 'blur' },
                ],
                station: [
                    { required: true, message: '请选择提箱场站', trigger: 'blur' },
                ],
                tons:[
                    { required: true, message: '请输入吨数', trigger: 'blur' },
                ]
            },
        };
    },
    watch: {
        dialogShow: {
            handler(newVal,oldVal) {
                if(newVal){
                    if(this.taskId !== ''){
                        // 查询详细信息
                        this.getCarTaskDetail()
                    } 
                    // 再来一单
                    if(this.mianTaskData.blNo){
                        this.form = this.mianTaskData
                    }
                    if(this.subTaskData.blNo){
                        this.subTaskForm = this.subTaskData;
                    }
                    this.getPort()
                    this.getGoodBy()
                    this.getcustomerList()
                    this.getdriverManList()
                    this.getcontainerTypeList()
                    this.getstationList()
                    this.getfeeNamelList()
                }
            },
            deep: true, // 深度监听
            immediate: true // 立即执行
        }
    },
    methods: {
        // 查询详细信息
        getCarTaskDetail(){
            this.$api.getCarTaskDetail( this.taskId ).then(res =>{
                const { subTask, ...form } = res; 
                this.form = form
                if(res.subTask === null){
                    this.subTaskForm = {
                        contactMan :'',
                        phone :'',
                        startPort:'黄岛',
                    };
                    this.subTaskForm.parentId = this.form.id
                }else{
                    this.subTaskForm = res.subTask;
                    // 有子任务查询费用和信息和上传文件
                    this.getFeeList(this.subTaskForm.id,'sub')
                    this.getAttachments(this.subTaskForm.id,'sub');
                }
                // 查询主任务费用信息
                this.getFeeList(this.taskId,'main')
                // 查询主任务上传文件
                this.getAttachments(this.taskId,'main');
            })
        },
        // 查询任务中的费用明细
        getFeeList(taskId,code){
            this.$api.getFeeList( taskId ).then(res =>{
                if(code === 'main'){
                    this.costInformationList = res
                    this.$forceUpdate()
                }else{
                    this.costInformationSubList = res
                    this.$forceUpdate()
                }
            })
        },
        // 查询地址
        getPort() {
            this.$api.getDicList( { value:'陆运站点'} ).then(res =>{
                this.portList = res
            })
        },
        // 查询详细地址
        getAddressBy(data) {
            this.$api.getAddressBy( data ).then(res =>{
                this.portDetailList = res
            })
        },
         // 获取委托列表
        getcustomerList(){
            this.$api.getDicList( { value:'委托单位'} ).then(res =>{
                this.customerList = res
            })
        },         
        // 获取箱型列表
        getcontainerTypeList(){
            this.$api.getDicList( { value:'箱型'} ).then(res =>{
                this.containerTypeList = res
            })
        },
        // 获取提箱场站
        getstationList(){
            this.$api.getDicList( { value:'场站'} ).then(res =>{
                this.stationList = res
            })
        },
        // 获取费用名称列表
        getfeeNamelList(){
            this.$api.getDicList( { value:'费用名称'} ).then(res =>{
                this.feeNamelList = res
            })
        },
        // 获取司机列表
        getdriverManList(){
            this.$api.getFreeDrivers().then(res =>{
                this.driverManList = res
            })
        },
        // 选择司机后带出车牌号--主任务
        selectTruckNo(data){
            for(var i=0;i<this.driverManList.length;i++){
                if(data === this.driverManList[i].driverName){
                    this.form.truckNo = this.driverManList[i].truckNo
                    return
                }
            }
        },
        // 清除司机后清除车牌号
        clearDriverMan(){
            this.form.truckNo = ''
        },
        // 选择司机后带出车牌号--子任务
        // selectTruckNoSubTask(data){
        //     for(var i=0;i<this.driverManList.length;i++){
        //         if(data === this.driverManList[i].driver){
        //             this.subTaskForm.truckNo = this.driverManList[i].vehicleNum
        //             return
        //         }
        //     }
        // },
        // 选择详细地址后带出联系人和电话
        endAddressChange(address){
            if(address !== ''){
                const data = address.split('-')
                this.form.endAddress = data[0]
                this.form.contactMan = data[1]
                this.form.phone = data[2]
                this.$forceUpdate();
            }
        },
        // 子任务
        endAddressChangeSubTask(address){
            if(address !== ''){
                const data = address.split('-')
                this.subTaskForm.endAddress = data[0]
                this.subTaskForm.contactMan = data[1]
                this.subTaskForm.phone = data[2]
                this.$forceUpdate();
            }
        },
         // 根据货物名称查询货物
         getGoodBy() {
                this.$api.getDicList( { value:'货物名称'} ).then(res =>{
                    this.goodsList = res
                })

            },
        // 详细目的地址可选可填，填写时--主任务
        selectBlur(e) {
            if (e.target.value !== '') {
                this.form.endAddress = e.target.value;
                this.$forceUpdate();   // 强制更新
            }
        },
        // 清空详细地址--主任务
        selectClear() {
            this.form.endAddress = '';
            this.$forceUpdate();
        },
        
        // 详细目的地址可选可填，填写时--子任务
        selectBlurSubTask(e) {
            if (e.target.value !== '') {
                this.subTaskForm.endAddress = e.target.value;
                this.$forceUpdate();   // 强制更新
            }
        },
        // 清空详细地址--子任务
        selectClearSubTask() {
            this.subTaskForm.endAddress = '';
            this.$forceUpdate();
        },
        // 关闭窗口
        handleClose() {
            const status = this.form.status
            this.$refs.mianform.resetFields()
            this.$refs.subForm.resetFields()
            this.form = {
                contactMan :'',
                phone :'',
                startPort:'黄岛',
            }
            this.subTaskForm = {
                contactMan :'',
                phone :'',
                startPort:'黄岛',
            }
            this.costInformationList = []
            this.costInformationSubList = []
            this.mainFileList = []
            this.subTaskFileList = []
            this.newmainFileList = []
            this.newSubFileList = []
            this.subDriverList = []
            this.mainDriverList = []
            this.tabsValue = 'maindetail'
            this.$emit('closeDialog', false,status);
        },
        // 保存主任务
        saveMian(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$api.insOrUpdateCarTask( this.form ).then(res =>{
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.form.id = res
                        this.subTaskForm.parentId = res
                        this.$forceUpdate()
                    })
                } else {
                    return false;
                }
            });
        },
        // 保存子任务
        saveSubTask(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 先查主任务信息，将主任务信息中的司机、车牌号、任务到场时间带入子任务
                    this.$api.getCarTaskDetail( this.subTaskForm.parentId ).then(res =>{
                        this.subTaskForm.driverMan = res.driverMan;
                        this.subTaskForm.truckNo = res.truckNo;
                        this.subTaskForm.requestTime = res.requestTime;
                        this.$api.insOrUpdateCarTask( this.subTaskForm ).then(res =>{
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.subTaskForm.id = res
                            this.$forceUpdate()
                        })
                    })
                    
                }
            })
        },
        // 生成运费    必须保存主任务有id 子任务同样保存有id后才可以生成运费
        shippingFee(code){
            if(code === 'main'){
                // 主任务生成运费
                if(this.form.id && this.form.id !== '' && this.form.taskType !== ''){
                    this.countFee(this.form.startPort,this.form.endPort,this.form.taskType,code)
                }else{
                    this.$message({
                        message: '请先保存主任务后再生成运费',
                        type: 'warning'
                    });
                }
            }else{
                // 子任务生成运费
                if(this.subTaskForm.id && this.subTaskForm.id !== '' && this.form.taskType !== ''){
                    this.countFee(this.subTaskForm.startPort,this.subTaskForm.endPort,this.subTaskForm.taskType,code)
                }else{
                    this.$message({
                        message: '请先保存子任务后再生成运费',
                        type: 'warning'
                    });
                }
            }
        },
        // 判断起始地和目的地是都填完整，完整查询应付运费
        countFee(startPort,endPort,taskType,code){
            var startPorts = startPort.replace('+','%2B')
            var endPorts = endPort.replace('+','%2B')
                if(startPort !== "" && endPort !== "" && taskType !== ""){
                    // 计算运费
                    this.$api.getAmountByConditions( startPorts,endPorts,taskType ).then(res =>{
                        const item = {
                            id:'',
                            taskId:  code === 'main' ? this.form.id : this.subTaskForm.id,
                            feeName:'陆运费',
                            amount:res,
                            note:'',
                            createMan:localStorage.getItem('name'),
                        }
                        if(code === 'main'){
                            this.costInformationList.push(item)
                        }else{
                            this.costInformationSubList.push(item)
                        }
                    })
                }else{
                    this.$message({
                        message: '请填写起始地址与目的地址',
                        type: 'warning'
                    });
                }

        },
        // 新增费用信息
        addCostInformation(code){
            if(code === 'main'){
                // 检测是否保存主任务
                if(this.form.id && this.form.id !== ''){
                    const item = {
                        id:'',
                        taskId: this.form.id,
                        feeName:'',
                        amount:0,
                        note:'',
                        createMan:localStorage.getItem('name'),
                        createTime:'',
                    }
                    this.costInformationList.push(item)
                }else{
                    this.$message({
                        message: '请先保存主任务后再添加运费',
                        type: 'warning'
                    });
                }
            }else{
                // 检测是否保存子任务
                if(this.subTaskForm.id && this.subTaskForm.id !== ''){
                    const item = {
                        id:'',
                        taskId: this.subTaskForm.id,
                        feeName:'',
                        amount:0,
                        note:'',
                        createMan:localStorage.getItem('name'),
                        createTime:'',
                    }
                    this.costInformationSubList.push(item)
                }else{
                    this.$message({
                        message: '请先保存子任务后再添加运费',
                        type: 'warning'
                    });
                }
            }
        },
        // 保存费用信息
        saveCostInformation(code){
            if(code === 'main'){ // 主任务
                // 检测费用信息列表长度
                if(this.costInformationList.length){
                    for(var i=0; i<this.costInformationList.length; i++){
                        if(this.costInformationList[i].feeName === '' || this.costInformationList[i].amount === 0){
                            this.$message({
                                message: '请填写完整费用信息且金额不能为0',
                                type: 'warning'
                            });
                            return false
                        }
                    }
                    // 保存
                    this.saveCostInformationAPI(this.costInformationList,'main')
                }else{
                    this.$message({
                        message: '请先创建费用信息',
                        type: 'warning'
                    });
                }
            }else{ // 子任务
                // 检测费用信息列表长度
                if(this.costInformationSubList.length){
                    // 保存
                    for(var i=0; i<this.costInformationSubList.length; i++){
                        if(this.costInformationSubList[i].feeName === '' || this.costInformationSubList[i].amount === 0){
                            this.$message({
                                message: '请填写完整费用信息且金额不能为0',
                                type: 'warning'
                            });
                            return false
                        }
                    }
                    this.saveCostInformationAPI(this.costInformationSubList,'sub')
                }else{
                    this.$message({
                        message: '请先创建费用信息',
                        type: 'warning'
                    });
                }
            }
        }, 
        // 调用保存费用接口
        saveCostInformationAPI(list,code){
            const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
            const executeWithThrottling = async (list, delayMs = 200) => {
                const results = [];
                for (const [index, item] of list.entries()) {
                    const { createTime, ...cleanItem } = item;      // 删除创建时间
                    try {
                    const res = await this.$api.insOrUpdateCarTaskFee(cleanItem);
                    results.push(res);
                    if (index < list.length - 1) await delay(delayMs); // 间隔执行
                    } catch (err) {
                    console.error(`第 ${index + 1} 项请求失败:`, err);
                    throw err; // 中断流程
                    }
                }
                return results;
            };
            // 调用方式
            executeWithThrottling(list)
            .then(() => {
                this.$message.success('保存成功');
                this.getFeeList(list[0].taskId, code);
            })
            .catch(error => {
                this.$message.error('部分保存失败');
                console.error('全局错误:', error);
            });
            // const arr = list.map(item => {
            //     const { createTime, ...cleanList } = item
            //     return this.$api.insOrUpdateCarTaskFee(cleanList) // 每个请求生成独立的 Promise
            // })
            // Promise.all(arr).then(results => {
            //     this.$message({
            //         message: '保存成功',
            //         type: 'success'
            //     });
            //     this.getFeeList(list[0].taskId,code);
            // })
            // .catch(error => {
            //     console.error(error);
            // });
        },
        // 删除费用信息
        delCostInformation(code){
            if(code === 'main'){ // 主任务
                if(this.selectCostInformation.length){
                    this.selectCostInformation.sort((a, b) => b - a); // 降序排列数组
                    this.costInformationList = this.delCostInformationAPI(this.selectCostInformation,this.costInformationList)
                }else{
                    // 如果选中的列表长度为0,则不进行删除
                    this.$message({
                        message: '请先选中费用信息',
                        type: 'warning'
                    });
                }
            }else{
                // 子任务
                if(this.selectCostInformationSub.length){
                    this.selectCostInformationSub.sort((a, b) => b - a); // 降序排列数组
                    this.costInformationSubList = this.delCostInformationAPI(this.selectCostInformationSub,this.costInformationSubList)
                }else{
                    // 如果选中的列表长度为0,则不进行删除
                    this.$message({
                        message: '请先选中费用信息',
                        type: 'warning'
                    });
                }
            }
            
        },
        // 调用删除费用信息接口
        delCostInformationAPI(numberList,list){
            const arr = numberList.map(item => {
                if(list[item].id !== ''){
                    this.$api.deleteCarTaskFee( list[item].id  )
                }
                list.splice(item, 1);
            })
            Promise.all(arr).then(results => {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
            })
            .catch(error => {
                console.error(error);
            });
            return list
        },
        // 刷新费用信息
        RefreshCostInformation(code){
            if(code === 'main'){
                if(this.form.id !== '' && this.form.id){
                    this.getFeeList(this.form.id,code)
                }else{
                    this.$message({
                        message: '请先保存主任务',
                        type: 'warning'
                    });
                }
            }else{
                if(this.subTaskForm.id !== '' && this.subTaskForm.id){
                    this.getFeeList(this.subTaskForm.id,code)
                }else{
                    this.$message({
                        message: '请先保存子任务',
                        type: 'warning'
                    });
                }
            }
        },
        // 选中的费用信息序号列表--主任务
        selectCostInformationChange(val){
            const selectedIndexes = val.map(row => {
                return this.costInformationList.indexOf(row); // 返回索引（0开始）
                });
            this.selectCostInformation = selectedIndexes
        },
        // 选中的费用信息序号列表--子任务
        selectCostInformationSubChange(val){
            const selectedIndexes = val.map(row => {
                return this.costInformationSubList.indexOf(row); // 返回索引（0开始）
                });
            this.selectCostInformationSub = selectedIndexes
        },
        // 文件上传时勾子--主任务
        handleChangeMain(file, fileList){
            this.mainFileList = fileList
        },
        // 文件上传时勾子--子任务
        handleChangeSub(file, fileList){
            this.subTaskFileList = fileList
        },
        // 移除文件勾子--主任务
        handleRemoveMain(file, fileList) {
            this.mainFileList = fileList
        },
        // 移除文件勾子--子任务
        handleRemoveSub(file, fileList) {
            this.subTaskFileList = fileList
        },
        // 上传文件
        uploadFiles(code){
            if(code === 'main'){
                if(this.form.id !== '' && this.form.id){
                    if(this.mainFileList.length){
                        this.uploadFilesAPI(this.form.id,this.mainFileList,code)
                    }else{
                        this.$message({
                            message: '请选择需要上传的文件',
                            type: 'warning'
                        });
                    }
                }else{
                    this.$message({
                        message: '请先保存主任务',
                        type: 'warning'
                    });
                }
            }else{
                // 子任务
                if(this.subTaskForm.id !== '' && this.subTaskForm.id){
                    if(this.subTaskFileList.length){
                        this.uploadFilesAPI(this.subTaskForm.id,this.subTaskFileList,code)
                    }else{
                        this.$message({
                            message: '请选择需要上传的文件',
                            type: 'warning'
                        });
                    }
                }else{
                    this.$message({
                        message: '请先保存子任务',
                        type: 'warning'
                    });
                }
            }
            
        },
        // 上传文件调用接口
        uploadFilesAPI(taskId,fileList,code){
            var newFileList = []
            const formData = new FormData();
            fileList.forEach(item => {
                formData.append('files', item.raw);
            });
            this.$api.uploadAttachments( taskId,localStorage.getItem('name'),formData ).then(res =>{
                this.$message({
                    message: '上传成功',
                    type: 'success'
                });
                if(code === 'main'){
                    this.mainFileList = []
                }else{
                    this.subTaskFileList = []
                }
                // 获取已上传的文件列表
                this.getAttachments(taskId,code)
            })
            return newFileList
        },
        // 查询已上传文件
        getAttachments(taskId,code){
            this.$api.getAttachments( taskId ).then(res =>{
                if(code === 'main'){
                    this.newmainFileList = []
                    this.mainDriverList = []
                    res.forEach( item => {
                        if(item.type === 'PC'){
                            this.newmainFileList.push(item)
                        }else{
                            this.mainDriverList.push(item.path)
                        }
                    })
                }else{
                    this.newSubFileList = []
                    this.subDriverList = []
                    res.forEach( item => {
                        if(item.type === 'PC'){
                            this.newSubFileList.push(item)
                        }else{
                            this.subDriverList.push(item.path)
                        }
                    })
                }
            })
        },
        // 预览文件
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.path,
                    annexName: data.fileName,
                    id:data.id
                }
            }
            var childWindow = window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
            var loop = setInterval(() => {
                if (childWindow.closed) {  // 检测子窗口是否关闭
                    clearInterval(loop); // 停止定时器
                    // 子窗口关闭后父页面刷新
                    this.getAttachments(this.form.id,'main')
                    if(this.subTaskForm.id !== '' && this.subTaskForm.id){
                        this.getAttachments(this.subTaskForm.id,'sub')
                    }
                }
            }, 100);
        },
    },
  };
</script>
<style lang="less" scoped>
.title{
    width: auto;
    padding: 20px;
    font-size: 20px;
    font-weight: bold;
}
.fee{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.label_box{
    display: flex;
    margin-bottom: 10px;
}
.label_box_item{
    display: flex;
    width: 50%;
}
.label{
    width: 120px;
    line-height:28px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box
}
.buttons{
    margin-bottom: 10px;
    margin-left: 20px;
}
.list-margin{
    margin-right: 10px;
}
.tipText{
    color: #a5a7aa;
    margin: -10px 0px 0px 10px;
    font-size: 13px;
}
::v-deep .el-form-item__content {
    width: 250px !important;
}
::v-deep .el-dialog__headerbtn {
    font-size: 24px !important;
}
::v-deep .el-dialog {
    margin: 20px auto !important;
}
</style>